import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Document,
    Page,
    pdfjs,
} from 'react-pdf';
import { Box } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { Spinner } from '../../..';
import { createBinaryBlob } from '../../../../helpers/viewerBinaryCache';
import { useCachedBinaryResource } from '../../../../viewer-cache';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

function NonClearAlignerPdf({
    prescriptionUrl,
}) {
    const {
        invalidate,
        resource,
        status,
    } = useCachedBinaryResource({
        type: 'pdf',
        url: prescriptionUrl,
    });
    const pdfData = useMemo(
        () => (resource ? createBinaryBlob(resource, 'application/pdf') : null),
        [resource],
    );
    const [numberOfPages, setNumberOfPages] = useState();
    const [renderFailed, setRenderFailed] = useState(false);
    const onPdfLoadSuccess = ({ numPages }) => {
        setNumberOfPages(numPages);
    };
    const onPdfLoadError = () => {
        invalidate();
        setRenderFailed(true);
        setNumberOfPages(undefined);
    };

    useEffect(() => {
        setRenderFailed(false);
        setNumberOfPages(undefined);
    }, [resource]);

    const isMissingPdf = !prescriptionUrl;
    const isFetching = status === 'loading';
    const hasFailed = isMissingPdf || status === 'failed' || renderFailed;
    const canRenderPdf = status === 'ready' && Boolean(pdfData) && !renderFailed;

    return (
        <>
            {
                isFetching && (
                    <Box className="pdf-loading-state">
                        <Spinner type="center" />
                    </Box>
                )
            }
            {
                !isFetching && canRenderPdf && (
                    <Box className="pdf-document" sx={{ border: 2, borderTop: 1, borderColor: 'divider', height: 'fit-content', width: 'fit-content' }}>
                        <Document
                            file={pdfData}
                            loading={() => ''}
                            onLoadError={onPdfLoadError}
                            onLoadSuccess={onPdfLoadSuccess}
                            onSourceError={onPdfLoadError}
                        >
                            {
                                Array.from(
                                    new Array(numberOfPages),
                                    (el, index) => (
                                        <Page
                                            key={`page_${index + 1}`}
                                            pageNumber={index + 1}
                                            loading={() => ''}
                                            scale={1.5}
                                            renderAnnotationLayer={false}
                                            renderTextLayer={false}
                                        />
                                    ),
                                )
                            }
                        </Document>
                    </Box>
                )
            }
            {
                !isFetching && hasFailed && (
                    <div className="left-panel dialog">
                        <i className="material-icons status failed" role="presentation">error</i>
                        Request failed with an error.
                    </div>
                )
            }
        </>
    );
}

NonClearAlignerPdf.propTypes = {
    prescriptionUrl: PropTypes.string.isRequired,
};

NonClearAlignerPdf.defaultProps = {};

export default NonClearAlignerPdf;
